import { all, takeEvery, put, call } from 'redux-saga/effects'
import topicsApi from 'services/topics'
import { actions } from './actions'

export function* loadTopics(courseId) {
  try {
    const response = yield call(topicsApi.loadTopics, courseId.payload)

    yield put({
      type: actions.LOAD_TOPICS_RESULT,
      payload: response,
    })
  } catch (error) {
    yield put({
      type: actions.LOAD_TOPICS_RESULT,
      error,
    })
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_TOPICS_REQUEST, loadTopics)])
}
